"use strict";

exports.__esModule = true;
exports.SaleClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const SaleClient = {
  getSale(saleNumber, id, contactEmail) {
    const idParam = `id=${id}`;
    const emailParam = `email=${contactEmail}`;
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_SALE, {
      saleNumber,
      extraParam: contactEmail ? emailParam : idParam
    });
    const requestId = 'GET_SALE';
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  getSaleList(page, size, bookingType, seperateRequest) {
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_SALE_LIST, {});
    const requestId = seperateRequest ? `GET_SALE_LIST_${bookingType}` : `GET_SALE_LIST`;
    return _http.$http.get(requestId, endPoint, {
      params: {
        page,
        size,
        type: 'all',
        bookingType
      }
    }).then(({
      data
    }) => data);
  }
};
exports.SaleClient = SaleClient;